import { render, staticRenderFns } from "./DetailSeller.vue?vue&type=template&id=37a0eeed&scoped=true&"
import script from "./DetailSeller.vue?vue&type=script&lang=js&"
export * from "./DetailSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a0eeed",
  null
  
)

export default component.exports